export class BackingItemArea {
  constructor(
    public readonly start: number,
    public readonly end: number,
  ) {}
}
